import { useMemo } from 'react';
import { usePlatformConfig } from '../usePlatformConfig';
const usePriceCurrency = () => {
    const { platformConfig: { priceDisplay }, } = usePlatformConfig();
    const isMultiCurrency = useMemo(() => {
        const hasSecondaryCurrency = !!priceDisplay?.secondary;
        return (hasSecondaryCurrency &&
            priceDisplay.primary.currency !== priceDisplay?.secondary?.currency);
    }, [priceDisplay]);
    return { isMultiCurrency };
};
export default usePriceCurrency;
//# sourceMappingURL=usePriceCurrency.js.map